import tokens from '../tokens/js/tokens';
// Definition of the "positive" color scheme
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
export const POSITIVE_LIGHT_HARD_DEFAULT = {
    background: tokens.colors.green[400].value,
    border: tokens.colors.green[400].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[900].value
};
// Light + Hard + Hover
export const POSITIVE_LIGHT_HARD_HOVER = {
    background: tokens.colors.green[500].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[800].value,
    foreground: tokens.colors.green[900].value
};
// Light + Hard + Pressed
export const POSITIVE_LIGHT_HARD_PRESSED = {
    background: tokens.colors.green[600].value,
    border: tokens.colors.green[600].value,
    foregroundAlt: tokens.colors.green[900].value,
    foreground: tokens.colors.green[900].value
};
// Light + Hard + Focus
export const POSITIVE_LIGHT_HARD_FOCUS = {
    background: tokens.colors.green[400].value,
    border: tokens.colors.green[400].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[900].value
};
// Light + Hard + Disabled
export const POSITIVE_LIGHT_HARD_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[150].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Soft + Default
export const POSITIVE_LIGHT_SOFT_DEFAULT = {
    background: tokens.colors.green[200].value,
    border: tokens.colors.green[400].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[900].value
};
// Light + Soft + Hover
export const POSITIVE_LIGHT_SOFT_HOVER = {
    background: tokens.colors.green[300].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[600].value,
    foreground: tokens.colors.green[900].value
};
// Light + Soft + Pressed
export const POSITIVE_LIGHT_SOFT_PRESSED = {
    background: tokens.colors.green[400].value,
    border: tokens.colors.green[700].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[900].value
};
// Light + Soft + Focus
export const POSITIVE_LIGHT_SOFT_FOCUS = {
    background: tokens.colors.green[200].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[900].value
};
// Light + Soft + Disabled
export const POSITIVE_LIGHT_SOFT_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + White + Default
export const POSITIVE_LIGHT_WHITE_DEFAULT = {
    background: tokens.colors.green[200].value,
    border: tokens.colors.green[400].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[900].value
};
// Light + White + Hover
export const POSITIVE_LIGHT_WHITE_HOVER = {
    background: tokens.colors.green[300].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[600].value,
    foreground: tokens.colors.green[900].value
};
// Light + White + Pressed
export const POSITIVE_LIGHT_WHITE_PRESSED = {
    background: tokens.colors.green[400].value,
    border: tokens.colors.green[700].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[900].value
};
// Light + White + Focus
export const POSITIVE_LIGHT_WHITE_FOCUS = {
    background: tokens.colors.green[200].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[900].value
};
// Light + White + Disabled
export const POSITIVE_LIGHT_WHITE_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Ghost + Default
export const POSITIVE_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[700].value
};
// Light + Ghost + Hover
export const POSITIVE_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: tokens.colors.green[700].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[700].value
};
// Light + Ghost + Pressed
export const POSITIVE_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[500].value
};
// Light + Ghost + Focus
export const POSITIVE_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[700].value
};
// Light + Ghost + Disabled
export const POSITIVE_LIGHT_GHOST_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Bare + Default
export const POSITIVE_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[700].value
};
// Light + Bare + Hover
export const POSITIVE_LIGHT_BARE_HOVER = {
    background: tokens.colors.green[150].value,
    border: tokens.colors.green[150].value,
    foregroundAlt: tokens.colors.green[600].value,
    foreground: tokens.colors.green[900].value
};
// Light + Bare + Pressed
export const POSITIVE_LIGHT_BARE_PRESSED = {
    background: tokens.colors.green[200].value,
    border: tokens.colors.green[200].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[900].value
};
// Light + Bare + Focus
export const POSITIVE_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[700].value
};
// Light + Bare + Disabled
export const POSITIVE_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
export const POSITIVE_DARK_HARD_DEFAULT = {
    background: tokens.colors.green[400].value,
    border: tokens.colors.green[400].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[900].value
};
// Dark + Hard + Hover
export const POSITIVE_DARK_HARD_HOVER = {
    background: tokens.colors.green[500].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[800].value,
    foreground: tokens.colors.green[900].value
};
// Dark + Hard + Pressed
export const POSITIVE_DARK_HARD_PRESSED = {
    background: tokens.colors.green[600].value,
    border: tokens.colors.green[600].value,
    foregroundAlt: tokens.colors.green[900].value,
    foreground: tokens.colors.green[900].value
};
// Dark + Hard + Focus
export const POSITIVE_DARK_HARD_FOCUS = {
    background: tokens.colors.green[400].value,
    border: tokens.colors.green[400].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[900].value
};
// Dark + Hard + Disabled
export const POSITIVE_DARK_HARD_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[850].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Soft + Default
export const POSITIVE_DARK_SOFT_DEFAULT = {
    background: tokens.colors.green[300].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[600].value,
    foreground: tokens.colors.green[900].value
};
// Dark + Soft + Hover
export const POSITIVE_DARK_SOFT_HOVER = {
    background: tokens.colors.green[300].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[600].value,
    foreground: tokens.colors.green[900].value
};
// Dark + Soft + Pressed
export const POSITIVE_DARK_SOFT_PRESSED = {
    background: tokens.colors.green[400].value,
    border: tokens.colors.green[700].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[900].value
};
// Dark + Soft + Focus
export const POSITIVE_DARK_SOFT_FOCUS = {
    background: tokens.colors.green[200].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[900].value
};
// Dark + Soft + Disabled
export const POSITIVE_DARK_SOFT_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + White + Default
export const POSITIVE_DARK_WHITE_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[500].value
};
// Dark + White + Hover
export const POSITIVE_DARK_WHITE_HOVER = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.green[300].value,
    foregroundAlt: tokens.colors.green[300].value,
    foreground: tokens.colors.green[300].value
};
// Dark + White + Pressed
export const POSITIVE_DARK_WHITE_PRESSED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.green[700].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[700].value
};
// Dark + White + Focus
export const POSITIVE_DARK_WHITE_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[500].value
};
// Dark + White + Disabled
export const POSITIVE_DARK_WHITE_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Ghost + Default
export const POSITIVE_DARK_GHOST_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[500].value
};
// Dark + Ghost + Hover
export const POSITIVE_DARK_GHOST_HOVER = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.green[300].value,
    foregroundAlt: tokens.colors.green[300].value,
    foreground: tokens.colors.green[300].value
};
// Dark + Ghost + Pressed
export const POSITIVE_DARK_GHOST_PRESSED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.green[700].value,
    foregroundAlt: tokens.colors.green[700].value,
    foreground: tokens.colors.green[700].value
};
// Dark + Ghost + Focus
export const POSITIVE_DARK_GHOST_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[500].value
};
// Dark + Ghost + Disabled
export const POSITIVE_DARK_GHOST_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Bare + Default
export const POSITIVE_DARK_BARE_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[500].value
};
// Dark + Bare + Hover
export const POSITIVE_DARK_BARE_HOVER = {
    background: tokens.colors.green[850].value,
    border: tokens.colors.green[850].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[500].value
};
// Dark + Bare + Pressed
export const POSITIVE_DARK_BARE_PRESSED = {
    background: tokens.colors.green[800].value,
    border: tokens.colors.green[800].value,
    foregroundAlt: tokens.colors.green[300].value,
    foreground: tokens.colors.green[300].value
};
// Dark + Bare + Focus
export const POSITIVE_DARK_BARE_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.green[500].value,
    foregroundAlt: tokens.colors.green[500].value,
    foreground: tokens.colors.green[500].value
};
// Dark + Bare + Disabled
export const POSITIVE_DARK_BARE_DISABLED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
export const POSITIVE_LIGHT_HARD = {
    default: POSITIVE_LIGHT_HARD_DEFAULT,
    disabled: POSITIVE_LIGHT_HARD_DISABLED,
    focus: POSITIVE_LIGHT_HARD_FOCUS,
    hover: POSITIVE_LIGHT_HARD_HOVER,
    pressed: POSITIVE_LIGHT_HARD_PRESSED
};
// Light + Soft
export const POSITIVE_LIGHT_SOFT = {
    default: POSITIVE_LIGHT_SOFT_DEFAULT,
    disabled: POSITIVE_LIGHT_SOFT_DISABLED,
    focus: POSITIVE_LIGHT_SOFT_FOCUS,
    hover: POSITIVE_LIGHT_SOFT_HOVER,
    pressed: POSITIVE_LIGHT_SOFT_PRESSED
};
// Light + White
export const POSITIVE_LIGHT_WHITE = {
    default: POSITIVE_LIGHT_WHITE_DEFAULT,
    disabled: POSITIVE_LIGHT_WHITE_DISABLED,
    focus: POSITIVE_LIGHT_WHITE_FOCUS,
    hover: POSITIVE_LIGHT_WHITE_HOVER,
    pressed: POSITIVE_LIGHT_WHITE_PRESSED
};
// Light + Ghost
export const POSITIVE_LIGHT_GHOST = {
    default: POSITIVE_LIGHT_GHOST_DEFAULT,
    disabled: POSITIVE_LIGHT_GHOST_DISABLED,
    focus: POSITIVE_LIGHT_GHOST_FOCUS,
    hover: POSITIVE_LIGHT_GHOST_HOVER,
    pressed: POSITIVE_LIGHT_GHOST_PRESSED
};
// Light + Tertiary
export const POSITIVE_LIGHT_BARE = {
    default: POSITIVE_LIGHT_BARE_DEFAULT,
    disabled: POSITIVE_LIGHT_BARE_DISABLED,
    focus: POSITIVE_LIGHT_BARE_FOCUS,
    hover: POSITIVE_LIGHT_BARE_HOVER,
    pressed: POSITIVE_LIGHT_BARE_PRESSED
};
// Dark + Hard
export const POSITIVE_DARK_HARD = {
    default: POSITIVE_DARK_HARD_DEFAULT,
    disabled: POSITIVE_DARK_HARD_DISABLED,
    focus: POSITIVE_DARK_HARD_FOCUS,
    hover: POSITIVE_DARK_HARD_HOVER,
    pressed: POSITIVE_DARK_HARD_PRESSED
};
// Dark + Soft
export const POSITIVE_DARK_SOFT = {
    default: POSITIVE_DARK_SOFT_DEFAULT,
    disabled: POSITIVE_DARK_SOFT_DISABLED,
    focus: POSITIVE_DARK_SOFT_FOCUS,
    hover: POSITIVE_DARK_SOFT_HOVER,
    pressed: POSITIVE_DARK_SOFT_PRESSED
};
// Dark + White
export const POSITIVE_DARK_WHITE = {
    default: POSITIVE_DARK_WHITE_DEFAULT,
    disabled: POSITIVE_DARK_WHITE_DISABLED,
    focus: POSITIVE_DARK_WHITE_FOCUS,
    hover: POSITIVE_DARK_WHITE_HOVER,
    pressed: POSITIVE_DARK_WHITE_PRESSED
};
// Dark + Ghost
export const POSITIVE_DARK_GHOST = {
    default: POSITIVE_DARK_GHOST_DEFAULT,
    disabled: POSITIVE_DARK_GHOST_DISABLED,
    focus: POSITIVE_DARK_GHOST_FOCUS,
    hover: POSITIVE_DARK_GHOST_HOVER,
    pressed: POSITIVE_DARK_GHOST_PRESSED
};
// Dark + Tertiary
export const POSITIVE_DARK_BARE = {
    default: POSITIVE_DARK_BARE_DEFAULT,
    disabled: POSITIVE_DARK_BARE_DISABLED,
    focus: POSITIVE_DARK_BARE_FOCUS,
    hover: POSITIVE_DARK_BARE_HOVER,
    pressed: POSITIVE_DARK_BARE_PRESSED
};
// Light
export const POSITIVE_LIGHT = {
    bare: POSITIVE_LIGHT_BARE,
    ghost: POSITIVE_LIGHT_GHOST,
    hard: POSITIVE_LIGHT_HARD,
    soft: POSITIVE_LIGHT_SOFT,
    white: POSITIVE_LIGHT_WHITE
};
// Dark
export const POSITIVE_DARK = {
    bare: POSITIVE_DARK_BARE,
    ghost: POSITIVE_DARK_GHOST,
    hard: POSITIVE_DARK_HARD,
    soft: POSITIVE_DARK_SOFT,
    white: POSITIVE_DARK_WHITE
};
// Color schema
const POSITIVE = {
    dark: POSITIVE_DARK,
    light: POSITIVE_LIGHT
};
export default POSITIVE;
//# sourceMappingURL=palette.schema.positive.js.map